import { type Actions, ActionType } from './users.actions';
import { initialState, type State, usersAdapter } from './users.state';

export function usersReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.FETCH_USERS:
            return {
                ...state,
                isPending: true
            };

        case ActionType.FETCH_USERS_SUCCEEDED:
            return usersAdapter.setAll(action.payload.users, { ...state, isLoaded: true, isPending: false });

        case ActionType.FETCH_USERS_FAILED:
            return {
                ...state,
                isLoaded: false,
                isPending: false
            };

        case ActionType.RESET: {
            return {
                ...initialState
            };
        }

        default:
            return state;
    }
}
